import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { AGENT_SETTINGS } from "@/constants/testIds";

const EMPTY_FORM = { question: "", answer: "", order: 0 };

/** Alta/edicion de una pregunta frecuente de la knowledge base del agente. */
export default function FaqModal({ open, onOpenChange, faq, onSubmit }) {
  const [form, setForm] = useState(EMPTY_FORM);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const isEdit = Boolean(faq);

  useEffect(() => {
    if (open) {
      setForm(faq ? { question: faq.question, answer: faq.answer, order: faq.order } : EMPTY_FORM);
      setError("");
    }
  }, [open, faq]);

  const handleSave = async () => {
    if (!form.question.trim() || !form.answer.trim()) {
      setError("Completa la pregunta y la respuesta");
      return;
    }
    setSaving(true);
    setError("");
    try {
      await onSubmit({ question: form.question.trim(), answer: form.answer.trim(), order: Number(form.order) || 0 }, faq);
      onOpenChange(false);
    } catch (err) {
      setError(err?.message || "No se pudo guardar la pregunta frecuente");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid={AGENT_SETTINGS.faqModal}>
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">{isEdit ? "Editar pregunta frecuente" : "Nueva pregunta frecuente"}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div>
            <Label className="text-sm text-muted-foreground mb-1 block">Pregunta</Label>
            <Input value={form.question} onChange={(e) => setForm((f) => ({ ...f, question: e.target.value }))} data-testid={AGENT_SETTINGS.faqQuestionInput} />
          </div>
          <div>
            <Label className="text-sm text-muted-foreground mb-1 block">Respuesta</Label>
            <Textarea value={form.answer} onChange={(e) => setForm((f) => ({ ...f, answer: e.target.value }))} rows={4} data-testid={AGENT_SETTINGS.faqAnswerInput} />
          </div>
          {error && <p className="text-sm text-destructive">{error}</p>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={handleSave} disabled={saving} data-testid={AGENT_SETTINGS.faqSaveButton}>
            {saving ? "Guardando..." : "Guardar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
